/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Toast_Order_Duplicate_SuccessInputs */

const vi_toast_order_duplicate_success = /** @type {(inputs: Toast_Order_Duplicate_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã sao chép thành đơn nháp ${i?.code}`)
};

/**

* @param {Toast_Order_Duplicate_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_duplicate_success = /** @type {((inputs: Toast_Order_Duplicate_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Duplicate_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_duplicate_success(inputs)
});